var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("mortgage-calculators-toolbar", {
                attrs: {
                  "show-calculate": false,
                  "is-loading": _vm.isLoading,
                  "loading-succeeded": _vm.loadingSucceeded,
                },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "run-report": _vm.runReport,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("b-row", { staticClass: "ml-1" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("financial-tools.mortgageIsolatorDescription")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      1. " +
                  _vm._s(_vm.$t("financial-tools.paymentFrequency")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.paymentFrequencyDescription"
                    ),
                    expression:
                      "\n          $t('financial-tools.paymentFrequencyDescription')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "3" } },
            [
              _c("select-section", {
                attrs: {
                  name: "frequency",
                  options: _vm.mortgageFrequencyOptions,
                  required: true,
                  "placeholder-option": false,
                },
                on: {
                  change: function ($event) {
                    return _vm.inoudata.doHideAMsched()
                  },
                },
                model: {
                  value: _vm.inoudata.frequency,
                  callback: function ($$v) {
                    _vm.$set(_vm.inoudata, "frequency", $$v)
                  },
                  expression: "inoudata.frequency",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      2. " +
                  _vm._s(_vm.$t("financial-tools.amortization_period")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.amortization_period_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.amortization_period_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c("years-months-section", {
                attrs: {
                  name: "amortizPeriodMths",
                  placeholder: "0",
                  "class-name": "fe-num-field",
                  "allow-minus": false,
                  label: _vm.$t("application-form.amortization").toString(),
                  "show-tooltip-message": true,
                },
                on: {
                  change: function ($event) {
                    return _vm.inoudata.doHideAMsched()
                  },
                },
                model: {
                  value: _vm.inoudata.amortizPeriodMths,
                  callback: function ($$v) {
                    _vm.$set(_vm.inoudata, "amortizPeriodMths", $$v)
                  },
                  expression: "inoudata.amortizPeriodMths",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.controlVars(2)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.calculate")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      3. " +
                  _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.mortgage_amount_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.mortgage_amount_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c("text-section", {
                attrs: {
                  name: "mortgageAmount",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.mortgage_amount").toString(),
                  "show-tooltip-message": true,
                  "max-length": 14,
                  max: "100000000",
                },
                on: {
                  change: function ($event) {
                    return _vm.inoudata.doHideAMsched()
                  },
                },
                model: {
                  value: _vm.inoudata.mortgageAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.inoudata, "mortgageAmount", $$v)
                  },
                  expression: "inoudata.mortgageAmount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.controlVars(3)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.calculate")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      4. " +
                  _vm._s(_vm.$t("financial-tools.interest_rate")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t("financial-tools.interest_rate_description"),
                    expression:
                      "\n          $t('financial-tools.interest_rate_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c("text-section", {
                attrs: {
                  placeholder: "0",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.interest_rate").toString(),
                  "max-length": 6,
                  max: "100",
                  "show-tooltip-message": true,
                },
                on: {
                  change: function ($event) {
                    return _vm.inoudata.doHideAMsched()
                  },
                },
                model: {
                  value: _vm.inoudata.interestRate,
                  callback: function ($$v) {
                    _vm.$set(_vm.inoudata, "interestRate", $$v)
                  },
                  expression: "inoudata.interestRate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.controlVars(4)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.calculate")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      5. " +
                  _vm._s(_vm.$t("financial-tools.mortgagePayment")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t("financial-tools.mortgagePaymentDescription"),
                    expression:
                      "\n          $t('financial-tools.mortgagePaymentDescription')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c("text-section", {
                attrs: {
                  name: "mortgagePayment",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.mortgagePayment").toString(),
                  "show-tooltip-message": true,
                  "max-length": 14,
                  max: "100000000",
                },
                on: {
                  change: function ($event) {
                    return _vm.inoudata.doHideAMsched()
                  },
                },
                model: {
                  value: _vm.inoudata.PandI,
                  callback: function ($$v) {
                    _vm.$set(_vm.inoudata, "PandI", $$v)
                  },
                  expression: "inoudata.PandI",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.controlVars(5)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.calculate")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.revisedAmortizationPeriod")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "2" } },
            [
              _c("years-months-section", {
                attrs: {
                  name: "revamortizPeriodMths",
                  placeholder: "0",
                  "class-name": "fe-num-field",
                  "allow-minus": false,
                  "hide-labels": false,
                  "show-tooltip-message": true,
                  disabled: true,
                },
                model: {
                  value: _vm.inoudata.revamortizPeriodMths,
                  callback: function ($$v) {
                    _vm.$set(_vm.inoudata, "revamortizPeriodMths", $$v)
                  },
                  expression: "inoudata.revamortizPeriodMths",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("mortgage-amschedule", {
        attrs: { inoudata: _vm.inoudata },
        on: { generated: _vm.generatedAmSchedule },
      }),
      _vm._v(" "),
      !_vm.inoudata.showAMsched
        ? _c(
            "div",
            { staticClass: "mt-4 text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white", disabled: _vm.isLoading },
                  on: {
                    click: function ($event) {
                      return _vm.amortLink(-1)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "financial-tools.calculate_amortization_schedule"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-row", { staticClass: "mt-4 ml-1" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }